import SelectCustomer from './SelectCustomer/SelectCustomer.vue';
import DestinationRegion from './DestinationRegion.vue';
import ServicesSelection from './ServicesSelection.vue';
import SelectPackages from './Packages.vue';
import SelectBundles from './Bundles.vue';
import ShippingAddress from './ShippingAddress.vue';
import BillingAddress from './BillingAddress.vue';
import ConfirmOrder from './Confirm.vue';

// OrderViewRoutes
export default [{
  path: '/order/:newId',
  name: 'place user order',
  props: true,
  component: () => import(/* webpackChunkName: "page-order-new" */ './Order.vue'),
  meta: {
    requiresAuth: true,
  },
  children: [
    {
      path: '',
      redirect: 'services_matrix'
    },
    {
      path: 'services_matrix',
      name: 'Services Selection',
      component: ServicesSelection,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: 'customer',
      name: 'Select Customer',
      component: SelectCustomer,
      meta: {
        requiresAuth: true,
      },
    },
    // {
    //   path: 'destination_region',
    //   name: 'Destination Region',
    //   component: DestinationRegion,
    //   meta: {
    //     requiresAuth: true,
    //   },
    // },
    {
      path: 'packages',
      name: 'Select Packages',
      component: SelectPackages,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: 'bundles',
      name: 'Select Bundles',
      component: SelectBundles,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: 'shipping_address',
      name: 'Shipping Address',
      component: ShippingAddress,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: 'billing_address',
      name: 'Billing Address',
      component: BillingAddress,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: 'confirm',
      name: 'Confirm Order',
      component: ConfirmOrder,
      meta: {
        requiresAuth: true,
      },
    }
  ],
}];
